export const SYNC_PROP_SELF_TENANT_UUID: string = 'selfTenantUuid';
export const SYNC_PROP_TENANT_UUID: string = 'tenantUuid';
export const SYNC_PROP_LANGUAGE: string = 'language';
export const SYNC_PROP_BRANDING: string = 'branding';
